'use client';

import { createContext, useContext } from 'react';
import { Thread } from '../thread/thread';

export const ThreadContext = createContext<{ thread: Thread } | undefined>(undefined);

export const ThreadProvider = ThreadContext.Provider;

export const useThreadContext = () => {
  const context = useContext(ThreadContext);
  if (!context) throw new Error('ThreadContext not found');
  return context;
};
